import NewMenuV2 from './NewMenuv2';

export default NewMenuV2;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Menu/NewMenu.jsx